import { forwardRef } from 'react';

import { tv } from './cn';

const kbdVariant = tv({
  base: 'rounded-md border border-b-2 border-border-secondary bg-bg-secondary px-1 py-0.5 text-xs text-text-primary',
});

export const Kbd = forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return <kbd className={kbdVariant({ className })} {...props} ref={ref} />;
  },
);
